import { Discount } from './discount';
import { IService, Service } from './service';

export interface ISoftware {
  id?: number;
  name?: string;
  desc?: string;
  status?: boolean;
  created_at?: string;
  updated_at?: string;
  services?: IService[];
  selectedService?: IService;
}

export class Software
  implements Omit<ISoftware, 'created_at' | 'updated_at' | 'desc' | 'status'>
{
  id?: number;
  name?: string;
  services: Service[] = [];
  selectedService?: Service;
  discount?: Discount;

  constructor(data?: ISoftware) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.selectedService = new Service(data.selectedService);
      this.services =
        data.services?.map((service) => new Service(service)) ?? [];
    }
  }
}
